export default __webpack_public_path__ + "static/media/bg2.18252781.jpg";